import React from 'react';
import TopBarVariant from './TopBarVariant';
import { StyledTopBarVariants } from './TopBarVariants.styles';

export const TopBarVariants = ({
    variants,
    onClick,
}: {
    variants: Array<{
        accessibility: string;
        svtId: string;
        name: string;
        urls: { svtplay: string };
    }>;
    onClick: (accessibility: string) => void;
}) => {
    if (!variants || variants.length === 0) {
        return null;
    }

    // "default" should be the last value in the array
    const sortedVariants = variants.sort((a, b) => (a.accessibility > b.accessibility ? 1 : -1));

    return (
        <StyledTopBarVariants>
            {sortedVariants.map((variant, i) => (
                <TopBarVariant key={`variant-${i}`} index={i} variant={variant} onClick={onClick} />
            ))}
        </StyledTopBarVariants>
    );
};

export default TopBarVariants;
